import { useClient } from '../ClientContext';

export const useActiveTokenCheck = () => {
  const { checkTokenValidity } = useClient();
  return { checkAndPromptIfNeeded: checkTokenValidity };
};
